import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { Button, ButtonBar } from '@ygtechnologies/rubus-ui';
import { BuyerOfferList } from '../buyer-offers';
import { BuyerOffer } from '@/types';

interface ChangeRequestOfferHistoryDialogProps {
    changeRequestId: number;
    show: boolean;
    onClose(): void;
    offers: BuyerOffer[] | null;
}

const ChangeRequestOfferHistoryDialog: React.FC<ChangeRequestOfferHistoryDialogProps> = ({
    show,
    onClose,
    changeRequestId,
    offers,
}) => {
    const handleCloseClick = () => {
        triggerHandler(onClose);
    };

    return (
        <Modal isOpen={show} toggle={handleCloseClick} size="xl">
            <ModalHeader>
                <Trans>Earlier offers - request #{changeRequestId}</Trans>
            </ModalHeader>
            <ModalBody>{offers ? <BuyerOfferList buyerOffers={offers} /> : <LoadingIndicator />}</ModalBody>
            <ModalFooter>
                <ButtonBar margins="none">
                    <ButtonBar.Right>
                        <Button variant="tertiary" onClick={handleCloseClick}>
                            <Trans>Close</Trans>
                        </Button>
                    </ButtonBar.Right>
                </ButtonBar>
            </ModalFooter>
        </Modal>
    );
};

export default ChangeRequestOfferHistoryDialog;